module.exports = __webpack_public_path__ + "static/media/energetics.43f9dac6.jpg";